var MpPageEquipmentsDetail;

(function() {
    if (!document.querySelector('#vue-body-equipment-detail')) {
        return;
    }

    MpPageEquipmentsDetail = new Vue({
        el: '#vue-body-equipment-detail',
        mixins: [MpVideoModal],
        data: {
            CONTACT_COUNTER_URL: '/equipment/addcounter',
            ID_MAIN: 'main',
            ID_SERVICES: 'services',
            ID_LOCATIONS: 'locations',

            // These props comes from EquipmentController PHP
            GOOGLE_ZOOM: google_zoom,
            MARKER_ICON_CURRENT: google_marker,

            latitude: '',
            longitude: '',
            marker: [],

            isMapShown: false,
            isContactShown: false,
            isLinkClicked: false,
            isInitialized: false,
        },

        computed: {},

        methods: {

            closeMapModal: function() {
                noScroll.off();
                this.isMapShown = false;
            },

            showMap: function(latitude, longitude) {
                this.latitude = latitude;
                this.longitude = longitude;

                this.marker = [new MapPoint({
                    lat: this.latitude,
                    lng: this.longitude,
                    icon: this.MARKER_ICON_CURRENT,
                })];

                noScroll.on();
                this.isMapShown = true;
            },

            registerContactAttempt: function() {
                // TOKEN is injected from Equipment PHP controller
                axios.post(this.CONTACT_COUNTER_URL, Serializer.serialize({
                    tk: TOKEN
                }));
            },

            showContactInfo: function(ev) {
                this.isContactShown = true;
                this.registerContactAttempt();

                setTimeout(function(target) {
                    window.location = target.getAttribute('href');
                }, 100, ev.currentTarget);
            },

            gotoWebsite: function(ev) {
                if (this.isLinkClicked) {
                    return;
                }

                ev.preventDefault();
                this.isLinkClicked = true;
                this.registerContactAttempt();

                setTimeout(function(target) {
                    target.click();
                }, 100, ev.currentTarget);
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },

        mounted: function() {
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
        }
    });

})();